// @ts-nocheck
import React from 'react'
import styles from './index.module.scss'
import { isWechat } from '@weike/toolkit'

export default function ComplaintSubmitResult() {
  const handleClose = () => {
    if (isWechat()) {
      const ua = navigator.userAgent.toLocaleLowerCase()
      const isMiniProgram =
        /miniprogram/.test(ua) ||
        (window as any).__wxjs_environment === 'miniprogram'
      if (isMiniProgram) {
        window.history.go(-(window.history.length - 1))
        return
      }
      const weixinJSBridge = (window as any).WeixinJSBridge
      if (typeof weixinJSBridge !== 'undefined') {
        weixinJSBridge.call('closeWindow')
      } else {
        document.addEventListener(
          'WeixinJSBridgeReady',
          function() {
            weixinJSBridge && (weixinJSBridge as any).call('closeWindow')
          },
          false,
        )
      }
    } else {
      try {
        window.history.go(-(window.history.length - 1))
      } catch (error) {
        console.log(error)
      }
    }
  }
  return (
    <div className={styles.container}>
      <img
        src={'https://img.lycheer.net/xupload/412/6967448cbb310d4cc8e560f7.png'}
        className={styles.icon}
      />
      <div className={styles.title}>投诉已提交</div>
      <div className={styles.desc}>
        我们会尽快核实，并通知你审核结果
        <br />
        感谢你的支持
      </div>

      <div className={styles.main_button} onClick={handleClose}>
        完成
      </div>
    </div>
  )
}
